<script setup lang="ts">
import { Toaster } from 'vue-sonner'
import { ModalsContainer } from 'vue-final-modal'
import { useRecaptchaProvider } from 'vue-recaptcha'
import { useHead } from '@unhead/vue'
import { TooltipProvider } from 'reka-ui'
import toastConfig from '@/config/toast'
import { isDark } from '@/composables/dark'
import { useCarrierBlockedRedirect } from '@/composables/carrier-blocked'

useRecaptchaProvider()
useCarrierBlockedRedirect()

const { locale: currentLocale } = useI18n()

useHead({
  title: '4Shipper by Transportly',
  htmlAttrs: {
    lang: currentLocale,
  },
})

const toastTheme = computed(() => isDark.value ? 'dark' : 'light')
</script>

<template>
  <TooltipProvider :delay-duration="200">
    <RouterView />
    <ModalsContainer />
    <Toaster v-bind="toastConfig" :theme="toastTheme" />
  </TooltipProvider>
</template>
